import request from '@/utils/request'

export function GetTeamDetails () {
  return request({
    url: 'post/team/GetTeamDetails'
  })
}

export function ForgotPassword(params){
  return request({
    url:'post/team/ForgotPassword',
    data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/team.js